import React from "react";
import { StyleSheet, View } from "react-native";

import { themes } from "@/Components/Styling/themeConfigs";

const SkeletonUserListItem = (): React.JSX.Element => {
  const currentTheme = themes.morning;

  const styles = StyleSheet.create({
    container: {
      height: 94.5,
      flexDirection: "row",
      alignItems: "center",
      padding: 8,
      borderColor: currentTheme.borderColor,
      borderStyle: "solid",
      borderBottomWidth: 0.5,
    },
    avatar: {
      width: 60,
      height: 60,
      borderRadius: 30,
      backgroundColor: "#E0E0E0",
    },
    textContainer: {
      marginLeft: 12,
      flex: 1,
    },
    line: {
      height: 15,
      backgroundColor: "#E0E0E0",
      borderRadius: 6,
      marginBottom: 6,
      width: "35%",
    },
    usernameLine: {
      width: "20%",
    },
    button: {
      height: 39,
      width: 100,
      borderRadius: 20,
      backgroundColor: "#E0E0E0",
      marginLeft: "auto",
      paddingVertical: 10,
      paddingHorizontal: 20,
    },
  });

  return (
    <View style={styles.container}>
      <View style={styles.avatar} />
      <View style={styles.textContainer}>
        <View style={[styles.line, styles.usernameLine]} />
        <View style={styles.line} />
        <View style={styles.line} />
      </View>
      <View>
        <View style={styles.button} />
      </View>
    </View>
  );
};

export default SkeletonUserListItem;
